//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import ColorPicker from 'components/Shared/ColorPicker/Index'
import { Field } from 'react-final-form'
import { STATUS_COLORS } from 'constants/colorMaps'

const ColorField = ({ name }) => {
  return (
    <Field
      name={name}
    >
      {({ input, meta }) => {
        return (
          <ColorPicker
            value={input.value}
            onChange={input.onChange}
            colorset={STATUS_COLORS}
          />
        )
      }}
    </Field>
  )
}

ColorField.propTypes = {
  name: PropTypes.string,
}

export default ColorField
